import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';

export const mutations: MutationTree<any> = {
  // 获取看板目录
  [TYPES.GET_BOARD_MENU.REQUEST](state: IState) {
    state.menu.loading = true;
  },
  [TYPES.GET_BOARD_MENU.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.menu.data = result;
    state.menu.loading = false;
  },
  [TYPES.GET_BOARD_MENU.FAILED](state: IState) {
    state.menu.loading = false;
  },
  // 获取报表用户权限
  [TYPES.GET_BOARD_ACCESS_USER.REQUEST](state: IState) {
    state.accessUser.loading = true;
  },
  [TYPES.GET_BOARD_ACCESS_USER.SUCCESS](state: IState, data) {
    state.accessUser.loading = false;
    const result = data.res.Data;
    state.accessUser.data = result ? result.Items : [];
    state.accessUser.total = result ? result.Total : 0;
  },
  [TYPES.GET_BOARD_ACCESS_USER.FAILED](state: IState) {
    state.accessUser.loading = false;
  },
  // 设置报表用户权限
  [TYPES.SET_BOARD_ACCESS_USER.REQUEST](state: IState, payload) {
    state.setAccessUser.success = false;
    state.setAccessUser.loading = true;
  },
  [TYPES.SET_BOARD_ACCESS_USER.SUCCESS](state: IState, data) {
    const result = data.res;
    state.setAccessUser.loading = false;
    state.setAccessUser.success = result && result.Success;
    Message.success(result.Message);
  },
  [TYPES.SET_BOARD_ACCESS_USER.FAILED](state: IState) {
    state.setAccessUser.loading = false;
  },
  // 设置后台管理员
  [TYPES.SET_BOARD_ADMIN_USER.REQUEST](state: IState, payload) {
    state.setAdminUser.success = false;
    state.setAdminUser.loading = true;
  },
  [TYPES.SET_BOARD_ADMIN_USER.SUCCESS](state: IState, data) {
    const result = data.res;
    state.setAdminUser.loading = false;
    state.setAdminUser.success = result && result.Success;
    Message.success(result.Message);
  },
  [TYPES.SET_BOARD_ADMIN_USER.FAILED](state: IState) {
    state.setAdminUser.loading = false;
  },
  // 获取列表数据
  [TYPES.GET_ProductDoc_list.REQUEST](state: IState, payload) {
    state.productDocs.success = false;
    state.productDocs.loading = true;
  },
  [TYPES.GET_ProductDoc_list.SUCCESS](state: IState, data) {
    const result = data.res;
    state.productDocs.loading = false;
    state.productDocs.infos = result.Data;
    state.productDocs.success = result && result.Success;
  },
  [TYPES.GET_ProductDoc_list.FAILED](state: IState) {
    state.productDocs.loading = false;
  },
  // 获取列表数据
  [TYPES.GET_ProductDoc_ById.REQUEST](state: IState, payload) {
  },
  [TYPES.GET_ProductDoc_ById.SUCCESS](state: IState, data) {
    const result = data.res;
    state.productDocById.infos = result.Data;
  },
  [TYPES.GET_ProductDoc_ById.FAILED](state: IState) {
  },

  // 获取列表数据
  [TYPES.GET_ProductEvn_list.REQUEST](state: IState, payload) {
    state.productEvns.success = false;
    state.productEvns.loading = true;
  },
  [TYPES.GET_ProductEvn_list.SUCCESS](state: IState, data) {
    const result = data.res;
    state.productEvns.loading = false;
    state.productEvns.infos = result.Data;
    state.productEvns.success = result && result.Success;
  },
  [TYPES.GET_ProductEvn_list.FAILED](state: IState) {
    state.productEvns.loading = false;
  },

  [TYPES.GET_Business_Doc_Types.REQUEST](state: IState, payload) {
  },
  // 获取列表数据
  [TYPES.GET_Business_Doc_Types.SUCCESS](state: IState, data) {
    const result = data.res;
    state.businessDocTypes = result.Data;
    state.businessUrl = result.Message;
  },
  [TYPES.GET_Business_Doc_Types.FAILED](state: IState) {
  },


  [TYPES.GET_Business_Git_Branchs.REQUEST](state: IState, payload) {
  },
  // 获取列表数据
  [TYPES.GET_Business_Git_Branchs.SUCCESS](state: IState, data) {
    const result = data.res;
    state.gitBranchInfo = result.Data;
  },
  [TYPES.GET_Business_Git_Branchs.FAILED](state: IState) {
  },

  // 保存表单
  [TYPES.SET_FORM_DATA.REQUEST](state: IState, payload) {
    state.saveForm.success = false;
    state.saveForm.loading = true;
  },
  [TYPES.SET_FORM_DATA.SUCCESS](state: IState, data) {
    const result = data.res;
    state.saveForm.loading = false;
    state.saveForm.success = result && result.Success;
    Message.success(result.Message);
  },
  [TYPES.SET_FORM_DATA.FAILED](state: IState) {
    state.saveForm.loading = false;
  },
  // 设置报表用户权限
  [TYPES.HAS_BOARD_HEAD_ACCESS.REQUEST](state: IState, payload) {
    state.hasBoardHead.loading = true;
  },
  [TYPES.HAS_BOARD_HEAD_ACCESS.SUCCESS](state: IState, data) {
    const result = data.res;
    state.hasBoardHead.loading = false;
    state.hasBoardHead.access = result && result.Data;
  },
  [TYPES.HAS_BOARD_HEAD_ACCESS.FAILED](state: IState) {
    state.hasBoardHead.loading = false;
  },
  // 获取管理员帐号
  [TYPES.ADMIN_USERS.REQUEST](state: IState) {
    state.adminUser.loading = true;
  },
  [TYPES.ADMIN_USERS.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.adminUser.loading = false;
    state.adminUser.infos = data;
  },
  [TYPES.ADMIN_USERS.FAILED](state: IState) {
    state.adminUser.infos = [];
    state.adminUser.loading = false;
  }
};
